/**
 * useAdjustElements
 * 
 * @Author: Focci
 * @Date: 2023-09-30 10:33:33
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-30 10:33:33
 */

import { isWindow } from '@lib/utils'
import { debounce } from 'lodash-es'
import { useEffect, useState } from 'react'

function getModuleOptionsCallback(el, selectors, enabled) {
  return function getModuleOptions() {
    if(!el) return
    
    const els = el.querySelectorAll(selectors)
    let len = els.length - 1

    for(; len >= 0; len--) {
      if(enabled) {
        const { scrollWidth, clientWidth } = el
        const fnName = scrollWidth > clientWidth ? 'add' : 'remove'
        els[len].classList[fnName]('hidden')
      } else {
        els[len].classList.remove('hidden')
      }
    }
  }
}

export default function useAdjustElements(
  selectors = '[data-adjust-el]'
) {
  const [el, setEl] = useState()
  const [enabled, setEnabled] = useState(false)

  useEffect(() => {
    const callback = getModuleOptionsCallback(el, selectors, enabled)
    const debounceCallback = debounce(callback, 300)

    callback()
    
    isWindow && window.addEventListener('resize', debounceCallback, false)
    return () => {
      isWindow && window.addEventListener('resize', debounceCallback, false)
    }
  }, [selectors, el, enabled])

  function watchElement(ele, enable) {
    setEl(ele)
    setEnabled(!!enable)
  }

  return {
    watchElement
  }
}
